// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_3HXRs","share-warp":"share-warp_Di4Ku"};